import { WidgetType } from '../../scorecard/core/template-definition.model';
import { Scorecard } from '../../scorecard/scorecard-next.model';

export function getYourTeamEnabled(selectedScorecard: Scorecard): boolean {
    let result: boolean;
    if (selectedScorecard?.data?.widgetTemplateConfig != null) {
        result = selectedScorecard.data.widgetTemplateConfig.widgets.some(
            (e) => {
                return e.widgetType === WidgetType.YOUR_TEAM && e.enabled;
            },
        );
    } else {
        result = false;
    }
    return result;
}
